import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ClientsService } from '@app/shared/services/clients.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
})
export class UserListComponent implements OnInit {
  clients: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  searchText: string = '';
  sortColumn: string = ''; // Track the column being sorted
  sortDirection: string = 'asc'; // 'asc' or 'desc'

  constructor(private clientsService: ClientsService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.getClients();
  }

  getClients() {
    this.clientsService.getClientList().subscribe(
      (data: any) => {
        this.clients = data;
        this.clients.reverse(); // Reverse order if needed
        this.sortByColumn(this.sortColumn); // Apply initial sort if needed
        this.cdr.detectChanges(); // Trigger change detection
      },
      (error) => {
        console.error('Error fetching clients:', error);
      }
    );
  }

  get paginatedClients(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.sortedClients
      .filter((client) => this.matchesSearch(client))
      .slice(startIndex, endIndex);
  }

  get sortedClients(): any[] {
    if (!this.sortColumn) {
      return this.clients;
    }
    return [...this.clients].sort((a, b) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];

      if (this.sortDirection === 'asc') {
        return (valueA > valueB) ? 1 : (valueA < valueB) ? -1 : 0;
      } else {
        return (valueA < valueB) ? 1 : (valueA > valueB) ? -1 : 0;
      }
    });
  }

  sortByColumn(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = (this.sortDirection === 'asc') ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.cdr.detectChanges(); // Trigger change detection if needed
  }

  // getNumberRange(end: number): number[] {
  //   return Array.from({ length: end }, (_, index) => index + 1);
  // }

  getNumberRange(end: number): number[] {
    return [this.currentPage];  // Only return the current page
  }
  

  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  ceil(value: number): number {
    return Math.ceil(value);
  }

  get totalItems(): number {
    return this.sortedClients.filter((client) => this.matchesSearch(client)).length;
  }

  // calculateRangeStart(): number {
  //   return (this.currentPage - 1) * this.itemsPerPage + 1;
  // }

  // calculateRangeEnd(): number {
  //   return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  // }

  calculateRangeStart(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }
  
  calculateRangeEnd(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  // onPageChange(page: number): void {
  //   this.currentPage = page;
  // }

  onPageChange(page: number): void {
    const totalPages = this.getTotalPages();
    
    // Only update the page if the new page number is within the valid range
    if (page >= 1 && page <= totalPages) {
      this.currentPage = page;
    }
  }
  

  onSearch(): void {
    this.currentPage = 1; // Reset to the first page when performing a new search
  }

  private matchesSearch(client: any): boolean {
    const searchFields = ['clientName', 'email', 'contactNo'];
    const lowerCaseSearch = this.searchText.toLowerCase();

    return searchFields.some((field) => {
      const fieldValue = client[field];
      if (fieldValue && typeof fieldValue === 'string') {
        return fieldValue.toLowerCase().includes(lowerCaseSearch);
      }
      return false;
    });
  }

  deleteSelectedEntries() {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    const selectedIds = [];
    
    checkboxes.forEach((checkbox) => {
      if ((checkbox as HTMLInputElement).checked) {
        selectedIds.push((checkbox as HTMLInputElement).dataset.id); // Assuming dataset.id is used for ID
      }
    });

    if (selectedIds.length > 0) {
      this.clientsService.deleteAllClients(selectedIds).subscribe(
        (response) => {
          console.log('Entries deleted successfully:', response);
          this.getClients(); // Fetch clients again after deletion
        },
        (error) => {
          console.error('Error deleting entries:', error);
        }
      );
    } else {
      console.log('No entries selected for deletion');
    }
  }

  selectAllChanged(event: Event) {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    checkboxes.forEach((checkbox) => {
      (checkbox as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
    });
  }
}
